module.exports = __webpack_public_path__ + "5c5f5a7bb2d0e07b1e69a80b75a0a1ca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/beady-10.png
// module id = 1995
// module chunks = 0